import Box from "@mui/material/Box";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import { useParams } from "react-router-dom";
import SubJobs from "./subjobs";
import SoftButton from "components/SoftButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import AlertMessage from "components/UI/AlertMessage";
import useAlert from "hooks/useAlert";
import Unauthorized from "components/UI/Unauthorized";
import { usePermissions } from "context/PermissionsContext";

const JobDetails = () => {
  const { id } = useParams();
  const { errorState, showAlert } = useAlert();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  if (!hasPermission("can_view_gwm")) {
    return <Unauthorized />;
  }

  const pagesList = [
    {
      name: "Job Details",
      route: "",
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar pagesList={pagesList} />

      <Card sx={{ mt: 3 }}>
        <SoftBox p={3}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Box sx={{ width: "100%" }}>
                <SubJobs id={id} />
              </Box>
            </Grid>
          </Grid>
        </SoftBox>
      </Card>
      <SoftBox display="flex" justifyContent="flex-start" mt={3}>
        <SoftButton
          variant="contained"
          startIcon={<ArrowBackIcon />}
          color="dark"
          onClick={() => {
            navigate(-1);
          }}
        >
          {t("lang.actions.back")}
        </SoftButton>
      </SoftBox>
      <AlertMessage {...errorState} />
    </DashboardLayout>
  );
};

export default JobDetails;
